import React, { Fragment, useEffect } from "react";
import HeadSection from "../components/services/HeadSection";
import MainSection from "../components/services/MainSection";
import Footer from "../components/footer/Footer";
import { Box } from "@material-ui/core";

export default function Services({ setTab }) {
  useEffect(() => setTab("Services"), [setTab]);

  return (
    <Fragment>
      <HeadSection />
      <Box style={{alignContent: "center"}}>        
        <MainSection />
        <Footer />
      </Box>
    </Fragment>
  );
}
